interface ToggleableLabel {
	id: string
	parentId: string | null
}

// Linear allows one label per label group, so picking a grouped label drops its siblings.
export function toggleLabelId(
	labels: readonly ToggleableLabel[],
	selectedIds: readonly string[],
	labelId: string,
): string[] {
	if (selectedIds.includes(labelId)) {
		return selectedIds.filter((id) => id !== labelId)
	}
	const parentId = labels.find((label) => label.id === labelId)?.parentId
	const kept = parentId
		? selectedIds.filter(
				(id) => labels.find((label) => label.id === id)?.parentId !== parentId,
			)
		: selectedIds
	return [...new Set([...kept, labelId])]
}
